import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from './components/Header/Header';
import Home from './pages/Home/Home';
import Footer from './components/Footer/Footer';
import './App.css'
import LoginLocation from './pages/LoginLocation/LoginLocation';
import LoginPhone from './pages/LoginPhone/LoginPhone';
import LoginOTP from './pages/LoginOTP/LoginOTP';
import Mainpage from './pages/Mainpage/Mainpage';
import RentConfirmation from './pages/RentConfirmation/RentConfirmation';
import PaymentMethod from './pages/PaymentMethod/PaymentMethod';
import { MallProvider } from './MallContext';
import Register from './pages/Register/Register';
import { LanguageProvider } from './LanguageProvider';

function App() {
  return (
    <LanguageProvider>
      <MallProvider>
        <Router>
          <div className="app-container">
            <Header />
            <div className="content">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login-location" element={<LoginLocation />} />
                <Route path="/login-phone" element={<LoginPhone />} />
                <Route path="/register" element={<Register />} />
                <Route path="/login-otp" element={<LoginOTP />} />
                <Route path="/mainpage" element={<Mainpage />} />
                <Route path="/rent-confirmation" element={<RentConfirmation />} />
                <Route path="/payment-method" element={<PaymentMethod />} />
              </Routes>
            </div>
            <Footer />
          </div>
        </Router>
      </MallProvider>
    </LanguageProvider>
  );
}

export default App;
